export default __webpack_public_path__ + "static/media/timer.ce0b62c8.svg";